import React from 'react';


const Footer = () => {
  return (
    <footer className="footer">
      <p>&copy; 2024 Rama Group of Institutes. All rights reserved.</p>
      <div className="social-links">
        <a href="#">Facebook</a> | <a href="#">Twitter</a> | <a href="#">Instagram</a>
      </div>
    </footer>
  );
};

export default Footer;
